import React, { useState } from "react";
import { SearchInputComponent } from "../../common/components";
import { UnsubscribedUsersFilterProps } from "./email-letter-types";
import Stack from "@mui/material/Stack";
import Badge from "@mui/material/Badge";
import FilterIcon from "../../assets/icons/filter-icon.svg";

const UnsubscribedUsersFilters: React.FC<UnsubscribedUsersFilterProps> = ({
  onSearch,
  isResetSearch = false,
  searchRef,
  isOpenFilter,
  setIsOpenFilter,
  selectedLeadsFilter,
}) => {
  return (
    <div className="campaign-list-search-filter-wrapper  email-letter-filters">
      <div className="campaign-list-search-wrapper">
        <SearchInputComponent
          placeholder="Search by Name, Email, Phone Number"
          onSearch={onSearch}
          isReset={isResetSearch}
          ref={searchRef}
        />
      </div>
      <div className="campaign-list-filter-wrapper">
        <div
          className="campaign-list-icon-filter"
          onClick={() => setIsOpenFilter?.(!isOpenFilter)}
          tabIndex={0}
        >
          <Stack spacing={4} direction="row" sx={{ color: "action.active" }}>
            <Badge
              color="secondary"
              badgeContent={selectedLeadsFilter}
              sx={{
                "& .MuiBadge-badge": {
                  backgroundColor: "#887952",
                },
              }}
            >
              <img src={FilterIcon} alt="Filter Icon" />
            </Badge>
          </Stack>
        </div>
      </div>
    </div>
  );
};

export default UnsubscribedUsersFilters;
